import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { DataService } from 'src/app/services/data.service';
import { CommonService, SiteService } from 'src/app/services/index';
import { AlertService, WarningDialog } from 'src/app/shared/index';
@Component({
  selector: 'app-manage-report',
  templateUrl: './manage-report.component.html',
  styleUrls: ['./manage-report.component.scss']
})
export class ManageReportComponent implements OnInit {
  siteId: string;
  selectedSite: string;
  sites: any;
  exportDataForm: UntypedFormGroup;
  displayAllSiteID: boolean;
  date = new UntypedFormControl(new Date());
  startView = 'month';
  max = new Date();
  constructor(
    private siteService: SiteService,
    private commonService: CommonService,
    private dataService: DataService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    this.exportDataForm = this.fb.group({
      siteCtr: ['', [Validators.required]]
      // dateCtr: []
    });
  }

  ngOnInit() {
    this.getSiteDetails();
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.displayAllSiteID = true;
    }
  }
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe((data) => {
      this.sites = data;
    });
  }
  regenrate() {
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.selectedSite = this.siteId;
    }
    const date = moment(this.date.value).format('YYYY-MM-DD');
    const url = this.commonService.getGenerateManageReport(
      this.selectedSite,
      date
    );
    this.showReport(url);
  }

  send() {
    const seft = this;
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.selectedSite = this.siteId;
    }
    const date = moment(this.date.value).format('YYYY-MM-DD');
    // const url = this.commonService.getGenerateTriggerMail(this.selectedSite, date);
    // this.showReport(url);
    this.siteService
      .getGenerateTriggerMail(this.selectedSite, date)
      .subscribe((data) => {
        if (data) {
          seft.showMessage(data.data, 'Bosch-Ic-information');
        }
      });
  }

  showReport(url) {
    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      } else {
        this.alertService.message = 'No data response !';
        this.alertService.showError(this.alertService.message);
      }
    });
  }
  showMessage(msg, newIconClass) {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = msg;
    dialogRef.componentInstance.newIconClass = newIconClass;

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }
}
